import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Balance.module.sass'
import Dropdown from '../../../components/Dropdown'
import Icon from '../../../components/Icon'
import SocketContext from 'context/context'
import { usePricingMonitor } from 'hooks/usePricingMonitor'
import AppLoader from '../../../components/AppLoader/index.js'


const counterOptions = ['7', '14']
function formatSymbol(symbol) {
  return symbol?.replace('/', '')?.replace('-', '')?.toLowerCase();
}
const Balance = (props) => {
  const [counter, setCounter] = useState(counterOptions[0])
  const { state } = useContext(SocketContext)
  const { orderBooks } = state
  const { selectedMarket } = props
  const [selectedOrderBooks, setSelectedOrderBooks] = useState(null)
  useEffect(() => {
    // console.log("orderBooksorderBooksorderBooks", orderBooks, selectedMarket)
    const books = orderBooks.find(
      (market) => {
        return formatSymbol(market?.pairName) === formatSymbol(selectedMarket)
      }
    )
    setSelectedOrderBooks(books)
  }, [selectedMarket, orderBooks])
  
  const pricingData = usePricingMonitor(selectedMarket)

if (!orderBooks || orderBooks.length === 0) {
    return (
      <AppLoader/>
    )
  }
  return (
    <div className={styles.balance}>
      <div className={styles.head}>
 
        <Dropdown
          className={styles.dropdown}
          classDropdownHead={styles.dropdownHead}
          classDropdownArrow={styles.dropdownArrow}
          classDropdownBody={styles.dropdownBody}
          classDropdownOption={styles.dropdownOption}
          value={counter}
          setValue={setCounter}
          options={counterOptions}
        />
      </div>
      <div className={styles.top}>
        <div className={styles.price}>
          Price ({selectedOrderBooks?.pairName?.replace('-', '/')?.split('/')?.[1]})
        </div>
        <div className={styles.amount}>
          Amounts ({selectedOrderBooks?.pairName?.replace('-', '/')?.split('/')?.[0]})
        </div>
      </div>
      <div className={styles.list}>
        {selectedOrderBooks &&
          selectedOrderBooks?.asks
            // ?.slice(0, parseInt(counterOptions) / 2)
            ?.slice(0, parseInt(counterOptions))
            ?.reverse()
            ?.map((x, index) => (
              <div
                className={cn(styles.statistics, styles.negative)}
                key={index}
              >
                <div className={styles.currency}>{x[0]}</div>
                <div className={styles.money}>{x[1]}</div>
              </div>
            ))}
        {selectedOrderBooks?.asks && selectedOrderBooks?.bids && pricingData && (
          <div
            className={cn(
              styles.statistics,
              styles.marketdata,
              parseFloat(pricingData?.percentage?.$numberDecimal ?? pricingData.percentage) >= 0 ? styles.positive : styles.negative,
            )}
          >
            <div className={styles.currency}>
              {pricingData?.currentPrice?.$numberDecimal ?? pricingData?.currentPrice} <Icon name={
                parseFloat( pricingData?.percentage?.$numberDecimal ?? pricingData.percentage) >= 0 ? 'arrow-top' : 'arrow-bottom'
              } size="35" />
            </div>
          </div>
        )}

        {selectedOrderBooks &&
          selectedOrderBooks?.bids
            // ?.slice(0, parseInt(counterOptions) / 2)
            ?.slice(0, parseInt(counterOptions))
            ?.reverse()
            ?.map((x, index) => (
              <div
                className={cn(styles.statistics, styles.positive)}
                key={index}
              >
                <div className={styles.currency}>{x[0]}</div>
                <Icon name="-top" size="16" />
                <div className={styles.money}>{x[1]}</div>
              </div>
            ))}
      </div>
    </div>
  )
}

export default Balance
